import {combineReducers} from 'redux';
import {routerReducer} from 'react-router-redux';
import Settings from './Settings';
import Auth from './Auth';
import Dashboard from './Dashboard';
import Patients from './Patients';
import SinglePatient from './SinglePatient';
import Appointment from './Appointment';
import NewInterventions from './NewInterventions';
import Payments from './Payments';
import Expenses from './Expenses';
import Company from './Company';
import Profile from './Profile';


const reducers = combineReducers ({
  routing: routerReducer,
  settings: Settings,
  auth: Auth,
  dashboard: Dashboard,
  patients: Patients,
  singlePatient: SinglePatient,
  appointment: Appointment,
  newInterventions: NewInterventions,
  payments: Payments,
  expenses: Expenses,
  companyData: Company,
  profile: Profile,
});

export default reducers;



// WEBPACK FOOTER //
// ./reducers/index.js